import { useMemo, useState } from "react"
import MDSelect from "components/MDSelect"
import { Field } from "../ui"

const EMAIL_VALUE = "__email__"
const PAGE = 50

export const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim())

const OptionLabel = ({ label, email }, { context }) =>
  context === "menu" && email ? (
    <div>
      <div>{label}</div>
      <div style={{ fontSize: 12, color: "var(--pc-muted, #8a93a5)" }}>{email}</div>
    </div>
  ) : (
    label
  )

// "Người làm Payment": one search box over GET /payment-assignees (name or
// email). A full email that isn't anyone's in the list becomes a "+ Dùng
// email" option, sent as paymentAssigneeEmail (BE resolves it). The endpoint
// returns everyone at once, so the menu renders PAGE rows and adds more as you
// scroll — the list stays a fixed height either way.
const PaymentAssigneePicker = ({ options, assigneeId, email, emailMode, onChange, disabled }) => {
  const [input, setInput] = useState("")
  const [visible, setVisible] = useState(PAGE)

  const query = input.trim().toLowerCase()
  const matched = useMemo(
    () => (query ? options.filter((o) => `${o.label} ${o.email || ""}`.toLowerCase().includes(query)) : options),
    [options, query]
  )
  const offerEmail = isValidEmail(query) && !options.some((o) => o.email?.toLowerCase() === query)

  const value = emailMode
    ? email
      ? { value: EMAIL_VALUE, label: email }
      : null
    : options.find((o) => o.value === String(assigneeId)) || null

  return (
    <Field
      label="Người làm Payment"
      required
      htmlFor="payment-assignee"
      hint="Ai sẽ thực hiện thanh toán. Người ngoài danh sách: gõ đủ email của họ."
    >
      <MDSelect
        inputId="payment-assignee"
        className="pc-md-select"
        options={[
          ...(offerEmail ? [{ value: EMAIL_VALUE, label: `+ Dùng email “${input.trim()}”` }] : []),
          ...matched.slice(0, visible),
        ]}
        value={value}
        onChange={(o) => {
          if (o?.value === EMAIL_VALUE) onChange({ emailMode: true, paymentAssigneeEmail: input.trim(), paymentAssigneeId: "" })
          else onChange({ emailMode: false, paymentAssigneeEmail: "", paymentAssigneeId: o?.value || "" })
        }}
        formatOptionLabel={OptionLabel}
        inputValue={input}
        onInputChange={(next, meta) => {
          if (meta.action === "input-change") {
            setInput(next)
            setVisible(PAGE)
          } else if (meta.action === "menu-close") {
            setInput("")
          }
        }}
        filterOption={null}
        onMenuScrollToBottom={() => setVisible((n) => (n < matched.length ? n + PAGE : n))}
        noOptionsMessage={() => "Không có trong danh sách — gõ đủ email để dùng người khác"}
        isDisabled={disabled}
        placeholder="Tìm theo tên hoặc email…"
      />
    </Field>
  )
}

export default PaymentAssigneePicker
